/*
    Mutation naming convention.

    UPDATE_ - Update the complete module store.
    SET_ - Update a single property in the module store.
    RESET_ - Clear the module store back to its original values.

    NOTE: We could of reused mutation names across all modules
    e.g. RESET, UPDATE, ADD to avoid types like SESSION_RESET_SESSION,
    but I think in the long run it is better to explicity state each mutation than be generic.
*/
export const SET_VERSION = 'setVersion';
export const SET_API_VERSION = 'setAPIVersion';
export const SET_INITIALISED = 'setInitialised';
export const SET_SEARCH_TEXT = 'setSearchText';
export const SET_CE_VERSION = 'setContenEngineVersion';

export const APP_SET_API_VERSION = `app/${SET_API_VERSION}`;
export const APP_SET_CE_VERSION = `app/${SET_CE_VERSION}`;
export const APP_SET_VERSION = `app/${SET_VERSION}`;
export const APP_SET_INITIALISED = `app/${SET_INITIALISED}`;
export const APP_SET_SEARCH_TEXT = `app/${SET_SEARCH_TEXT}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_SESSION = 'resetSession';
export const SET_IDP_URI = 'setIdpUri';
export const SET_REDIRECT_URI = 'setRedirectUri';
export const SET_FQDN = 'setFqdn';
export const SET_SUBDOMAIN = 'setSubdomain';
export const SET_ROLE = 'setRole';
export const SET_TOKEN_EXPIRY = 'setTokenExpiry';
export const SET_REFRESH_TOKEN = 'setRefreshToken';
export const SET_INTERRUPT_REFRESH_TOKEN = 'setInterruptRefreshToken';
export const SET_SITE_TYPE = 'setSiteType';

export const SESSION_RESET_SESSION = `session/${RESET_SESSION}`;
export const SESSION_SET_IDP_URI = `session/${SET_IDP_URI}`;
export const SESSION_SET_REDIRECT_URI = `session/${SET_REDIRECT_URI}`;
export const SESSION_SET_FQDN = `session/${SET_FQDN}`;
export const SESSION_SET_SUBDOMAIN = `session/${SET_SUBDOMAIN}`;
export const SESSION_SET_ROLE = `session/${SET_ROLE}`;
export const SESSION_SET_TOKEN_EXPIRY = `session/${SET_TOKEN_EXPIRY}`;
export const SESSION_SET_REFRESH_TOKEN = `session/${SET_REFRESH_TOKEN}`;
export const SESSION_SET_INTERRUPT_REFRESH_TOKEN = `session/${SET_INTERRUPT_REFRESH_TOKEN}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_APPEARANCE = 'resetAppearance';
export const SET_SIDE_NAV = 'setSideNav';
export const TOGGLE_SIDE_NAV = 'toggleSideNav';
export const SET_SEARCH_PANEL = 'setSearchPanel';
export const SET_SNACKBAR_TEXT = 'setSnackbarText';
export const SET_ALERT = 'setAlert';
export const RESET_ALERT = 'resetAlert';
export const SET_THEME = 'setTheme';
export const SET_DEFAULT_CURSOR = 'setDefaultCursor';
export const SET_PROGRESS_CURSOR = 'setProgressCursor';
export const SET_VIEW_TITLE = 'setViewTitle';
export const SET_FULLSCREEN = 'setFullscreen';
export const SET_ISMOBILE = 'setIsMobile';
export const SET_PREFERENCES_VIEW = 'setPreferencesView';

export const APPEARANCE_RESET_APPEARANCE = `appearance/${RESET_APPEARANCE}`;
export const APPEARANCE_SET_SIDE_NAV = `appearance/${SET_SIDE_NAV}`;
export const APPEARANCE_TOGGLE_SIDE_NAV = `appearance/${TOGGLE_SIDE_NAV}`;
export const APPEARANCE_SET_SEARCH_PANEL = `appearance/${SET_SEARCH_PANEL}`;
export const APPEARANCE_SET_SNACKBAR_TEXT = `appearance/${SET_SNACKBAR_TEXT}`;
export const APPEARANCE_SET_ALERT = `appearance/${SET_ALERT}`;
export const APPEARANCE_RESET_ALERT = `appearance/${RESET_ALERT}`;
export const APPEARANCE_SET_THEME = `appearance/${SET_THEME}`;
export const APPEARANCE_SET_DEFAULT_CURSOR = `appearance/${SET_DEFAULT_CURSOR}`;
export const APPEARANCE_SET_PROGRESS_CURSOR = `appearance/${SET_PROGRESS_CURSOR}`;
export const APPEARANCE_SET_VIEW_TITLE = `appearance/${SET_VIEW_TITLE}`;
export const APPEARANCE_SET_FULLSCREEN = `appearance/${SET_FULLSCREEN}`;
export const APPEARANCE_SET_ISMOBILE = `appearance/${SET_ISMOBILE}`;
export const APPEARANCE_SET_PREFERENCES_VIEW = `appearance/${SET_PREFERENCES_VIEW}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_CLIENT = 'resetClient';
export const UPDATE_CLIENT = 'updateClient';

export const CLIENT_RESET_CLIENT = `client/${RESET_CLIENT}`;
export const CLIENT_UPDATE_CLIENT = `client/${UPDATE_CLIENT}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_ACTIVATED_CEMODULES = 'resetActivatedCEModules';
export const BULK_ADD_ACTIVATED_CEMODULES = 'bulkAddActivatedCEModules';

export const CEMODULES_RESET_ACTIVATED_CEMODULES =
    `activatedCEModules/${RESET_ACTIVATED_CEMODULES}`;
export const CEMODULES_BULK_ADD_ACTIVATED_CEMODULES =
    `activatedCEModules/${BULK_ADD_ACTIVATED_CEMODULES}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_PUBLISHED = 'resetPublished';
export const BULK_ADD_APPLIED_UPDATES = 'bulkAddAppliedUpdates';
export const BULK_ADD_COMPLISPACE_PUBLISHED = 'bulkAddComplispacePublished';

export const PUBLICATIONS_RESET_PUBLISHED = `published/${RESET_PUBLISHED}`;
export const PUBLICATIONS_BULK_ADD_APPLIED_UPDATES =
    `published/${BULK_ADD_APPLIED_UPDATES}`;
export const PUBLICATIONS_BULK_ADD_COMPLISPACE_PUBLISHED =
    `published/${BULK_ADD_COMPLISPACE_PUBLISHED}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_NAVIGATION = 'resetNavigation';
export const SET_NAVIGATION = 'setNavigation';
export const SET_CURRENT_PAGE = 'setCurrentPage';

export const NAVIGATION_RESET_NAVIGATION = `navigation/${RESET_NAVIGATION}`;
export const NAVIGATION_SET_NAVIGATION = `navigation/${SET_NAVIGATION}`;
export const NAVIGATION_SET_CURRENT_PAGE = `navigation/${SET_CURRENT_PAGE}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_CLIENT_CONTEXT = 'resetClientContext';
export const BULK_ADD_CLIENT_CONTEXT_ITEMS = 'bulkAddClientContextItems';
export const UPDATE_CLIENT_CONTEXT_ITEM = 'updateClientContextItem';

export const CLIENT_CONTEXT_RESET_CLIENT_CONTEXT =
    `clientContext/${RESET_CLIENT_CONTEXT}`;
export const CLIENT_CONTEXT_BULK_ADD_CLIENT_CONTEXT_ITEMS =
    `clientContext/${BULK_ADD_CLIENT_CONTEXT_ITEMS}`;
export const CLIENT_CONTEXT_UPDATE_CLIENT_CONTEXT_ITEM =
    `clientContext/${UPDATE_CLIENT_CONTEXT_ITEM}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_QUICK_LINK_CONTENT = 'resetQuickLinkContent';
export const ASSIGN_LIST = 'assignList';



// WEBPACK FOOTER //
// ./src/store/mutationTypes.js